import apiFetch from '@wordpress/api-fetch';
import { HOOKS } from './constants';
import { hooks } from './hooks';

export async function submitCheckout(
	endpoint: string,
	body: Record<string, unknown>,
) {
	body = hooks.applyFilters(HOOKS.PAYLOAD, body) as Record<string, unknown>;

	try {
		let response = await apiFetch({
			path: endpoint,
			method: 'POST',
			data: body,
		});
		response = hooks.applyFilters(HOOKS.RESPONSE, response);
		return response;
	} catch (error: any) {
		throw hooks.applyFilters(HOOKS.RESPONSE, error);
	}
}
